export const idlFactory = ({ IDL }) => {
    const FileTreeNode = IDL.Rec();
    const CanisterMetadata = IDL.Record({
        'subType' : IDL.Opt(IDL.Text),
        'canisterType' : IDL.Text,
        'name' : IDL.Text,
        'didInterface' : IDL.Opt(IDL.Text),
        'stableInterface' : IDL.Opt(IDL.Text),
        'project' : IDL.Opt(IDL.Text),
    });
    const Result_6 = IDL.Variant({ 'ok' : IDL.Text, 'err' : IDL.Text });
    const RoleType = IDL.Variant({
        'Custom' : IDL.Text,
        'Developer' : IDL.Null,
        'Reviewer' : IDL.Null,
        'Contributor' : IDL.Null,
    });
    const Timestamp = IDL.Nat64;
    const Result_3 = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
    const DeploymentReference = IDL.Record({
        'id' : IDL.Text,
        'status' : IDL.Text,
        'name' : IDL.Text,
        'lastUpdated' : IDL.Nat64,
        'network' : IDL.Text,
        'projectId' : IDL.Text,
        'canisterId' : IDL.Opt(IDL.Principal),
    });
    const VersionStatus = IDL.Variant({
        'Released' : IDL.Null,
        'Draft' : IDL.Null,
        'Deprecated' : IDL.Null,
        'Development' : IDL.Null,
    });
    const NPMPackageInfo = IDL.Record({
        'dependencyType' : IDL.Text,
        'name' : IDL.Text,
        'version' : IDL.Text,
    });
    const PackageInfo = IDL.Record({
        'dir' : IDL.Opt(IDL.Vec(IDL.Text)),
        'name' : IDL.Text,
        'homepage' : IDL.Opt(IDL.Vec(IDL.Text)),
        'repo' : IDL.Text,
        'version' : IDL.Text,
    });
    const SemanticVersion = IDL.Record({
        'major' : IDL.Nat,
        'minor' : IDL.Nat,
        'build' : IDL.Opt(IDL.Text),
        'patch' : IDL.Nat,
        'prerelease' : IDL.Opt(IDL.Text),
    });
    const ProjectVersion = IDL.Record({
        'id' : IDL.Text,
        'status' : VersionStatus,
        'deployments' : IDL.Opt(IDL.Vec(DeploymentReference)),
        'created' : IDL.Nat64,
        'name' : IDL.Text,
        'tags' : IDL.Vec(IDL.Text),
        'description' : IDL.Opt(IDL.Text),
        'npmPackages' : IDL.Opt(IDL.Vec(NPMPackageInfo)),
        'releaseNotes' : IDL.Opt(IDL.Text),
        'parentVersion' : IDL.Opt(IDL.Text),
        'projectId' : IDL.Text,
        'artifactSnapshot' : IDL.Opt(IDL.Text),
        'canisters' : IDL.Vec(IDL.Principal),
        'motokoPackages' : IDL.Opt(IDL.Vec(PackageInfo)),
        'semanticVersion' : SemanticVersion,
    });
    const Result_2 = IDL.Variant({ 'ok' : ProjectVersion, 'err' : IDL.Text });
    const Visibility = IDL.Variant({
        'Contacts' : IDL.Null,
        'Private' : IDL.Null,
        'Public' : IDL.Null,
    });
    const ImageAsset = IDL.Record({
        'height' : IDL.Opt(IDL.Nat),
        'data' : IDL.Vec(IDL.Nat8),
        'name' : IDL.Text,
        'mimeType' : IDL.Text,
        'sizeBytes' : IDL.Nat,
        'width' : IDL.Opt(IDL.Nat),
        'uploadedAt' : IDL.Nat64,
    });
    const TemplatePricing = IDL.Record({
        'subscription' : IDL.Opt(IDL.Bool),
        'promotionExpiresAt' : IDL.Opt(IDL.Nat64),
        'acceptedPaymentMethods' : IDL.Opt(IDL.Vec(IDL.Text)),
        'currency' : IDL.Text,
        'discount' : IDL.Opt(IDL.Nat),
        'promotionalPrice' : IDL.Opt(IDL.Nat64),
        'paymentTerms' : IDL.Opt(IDL.Text),
        'price' : IDL.Nat64,
    });
    const TemplateStats = IDL.Record({
        'popularityScore' : IDL.Opt(IDL.Float64),
        'created' : IDL.Nat64,
        'revenue' : IDL.Opt(IDL.Nat64),
        'views' : IDL.Nat,
        'usageCount' : IDL.Nat,
        'updated' : IDL.Nat64,
        'conversionRate' : IDL.Opt(IDL.Float64),
        'averageDailyDownloads' : IDL.Opt(IDL.Float64),
        'rating' : IDL.Opt(IDL.Float64),
        'reviewCount' : IDL.Nat,
        'downloads' : IDL.Nat,
    });
    const TemplateVersion = IDL.Record({
        'publishedAt' : IDL.Nat64,
        'isDeprecated' : IDL.Bool,
        'downloadUrl' : IDL.Text,
        'releaseNotes' : IDL.Opt(IDL.Text),
        'version' : IDL.Text,
        'changes' : IDL.Vec(IDL.Text),
    });
    const TemplateLicense = IDL.Record({
        'requiresAttribution' : IDL.Bool,
        'allowModification' : IDL.Bool,
        'licenseType' : IDL.Text,
        'customTerms' : IDL.Opt(IDL.Text),
        'allowCommercialUse' : IDL.Bool,
    });
    const Template = IDL.Record({
        'id' : IDL.Text,
        'creatorPayoutAddress' : IDL.Opt(IDL.Text),
        'previewImageAssets' : IDL.Opt(IDL.Vec(ImageAsset)),
        'subCategory' : IDL.Opt(IDL.Text),
        'thumbnail' : IDL.Opt(IDL.Text),
        'installationInstructions' : IDL.Opt(IDL.Text),
        'publishingStatus' : IDL.Text,
        'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
        'documentation' : IDL.Opt(IDL.Text),
        'name' : IDL.Text,
        'tags' : IDL.Vec(IDL.Text),
        'supportUrl' : IDL.Opt(IDL.Text),
        'videoPreview' : IDL.Opt(IDL.Text),
        'description' : IDL.Text,
        'downloadUrl' : IDL.Text,
        'author' : IDL.Principal,
        'pricing' : IDL.Opt(TemplatePricing),
        'version' : IDL.Text,
        'stats' : IDL.Opt(TemplateStats),
        'versionHistory' : IDL.Opt(IDL.Vec(TemplateVersion)),
        'currentVersion' : TemplateVersion,
        'isFeatured' : IDL.Bool,
        'projectId' : IDL.Text,
        'creatorAccount' : IDL.Principal,
        'moderationStatus' : IDL.Opt(IDL.Text),
        'dependencies' : IDL.Opt(IDL.Vec(IDL.Text)),
        'demoUrl' : IDL.Opt(IDL.Text),
        'category' : IDL.Text,
        'searchKeywords' : IDL.Opt(IDL.Vec(IDL.Text)),
        'requirements' : IDL.Opt(IDL.Text),
        'license' : IDL.Opt(TemplateLicense),
        'previewImages' : IDL.Opt(IDL.Vec(IDL.Text)),
        'thumbnailImage' : IDL.Opt(ImageAsset),
    });
    const Result_5 = IDL.Variant({ 'ok' : Template, 'err' : IDL.Text });
    const FileContent = IDL.Variant({
        'Binary' : IDL.Vec(IDL.Nat8),
        'Text' : IDL.Text,
    });
    const ChunkId = IDL.Nat;
    const CodeArtifact = IDL.Record({
        'id' : IDL.Text,
        'content' : IDL.Opt(FileContent),
        'path' : IDL.Text,
        'size' : IDL.Nat,
        'mimeType' : IDL.Text,
        'fileName' : IDL.Text,
        'lastModified' : IDL.Int,
        'language' : IDL.Text,
        'version' : IDL.Nat,
        'projectId' : IDL.Text,
        'chunks' : IDL.Opt(IDL.Vec(IDL.Tuple(ChunkId, IDL.Nat))),
    });
    const Result_7 = IDL.Variant({ 'ok' : CodeArtifact, 'err' : IDL.Text });
    const ArtifactContent = IDL.Variant({
        'Binary' : IDL.Vec(IDL.Nat8),
        'Text' : IDL.Text,
        'Reference' : IDL.Text,
    });
    const ArtifactFile = IDL.Record({
        'content' : ArtifactContent,
        'path' : IDL.Text,
        'mimeType' : IDL.Text,
        'fileName' : IDL.Text,
        'lastModified' : IDL.Nat64,
        'language' : IDL.Text,
    });
    const Result_12 = IDL.Variant({ 'ok' : ArtifactFile, 'err' : IDL.Text });
    const FileData = IDL.Record({
        'content' : FileContent,
        'path' : IDL.Text,
        'mimeType' : IDL.Text,
        'fileName' : IDL.Text,
        'language' : IDL.Text,
    });
    const Result_14 = IDL.Variant({
        'ok' : IDL.Vec(CodeArtifact),
        'err' : IDL.Text,
    });
    const ProjectType__1 = IDL.Record({
        'subType' : IDL.Text,
        'name' : IDL.Text,
    });
    const Project = IDL.Record({
        'id' : IDL.Text,
        'status' : IDL.Text,
        'created' : IDL.Nat64,
        'projectType' : ProjectType__1,
        'templateId' : IDL.Opt(IDL.Text),
        'name' : IDL.Text,
        'description' : IDL.Opt(IDL.Text),
        'npmPackages' : IDL.Opt(IDL.Vec(NPMPackageInfo)),
        'collaborators' : IDL.Opt(IDL.Vec(IDL.Principal)),
        'canisters' : IDL.Vec(IDL.Principal),
        'updated' : IDL.Nat64,
        'workingCopyBaseVersion' : IDL.Opt(IDL.Text),
        'motokoPackages' : IDL.Opt(IDL.Vec(PackageInfo)),
        'visibility' : IDL.Text,
    });
    const VersionArtifact = IDL.Record({
        'id' : IDL.Text,
        'files' : IDL.Vec(ArtifactFile),
        'versionId' : IDL.Text,
        'created' : IDL.Nat64,
        'projectId' : IDL.Text,
    });
    const Result_11 = IDL.Variant({ 'ok' : VersionArtifact, 'err' : IDL.Text });
    const Result_25 = IDL.Variant({
        'ok' : IDL.Record({
            'content' : IDL.Vec(IDL.Nat8),
            'size' : IDL.Nat,
            'mimeType' : IDL.Text,
        }),
        'err' : IDL.Text,
    });
    const Result_24 = IDL.Variant({
        'ok' : IDL.Record({
            'files' : IDL.Vec(CodeArtifact),
            'isLastBatch' : IDL.Bool,
        }),
        'err' : IDL.Text,
    });
    const Result_23 = IDL.Variant({ 'ok' : IDL.Vec(IDL.Nat8), 'err' : IDL.Text });
    const Result_1 = IDL.Variant({ 'ok' : IDL.Bool, 'err' : IDL.Text });
    const DeploymentReference__1 = IDL.Record({
        'id' : IDL.Text,
        'status' : IDL.Text,
        'name' : IDL.Text,
        'lastUpdated' : Timestamp,
        'network' : IDL.Text,
        'projectId' : IDL.Text,
        'canisterId' : IDL.Opt(IDL.Principal),
    });
    const TemplateReference = IDL.Record({
        'id' : IDL.Text,
        'name' : IDL.Text,
        'salesCount' : IDL.Nat,
        'price' : IDL.Opt(IDL.Nat64),
        'visibility' : Visibility,
    });
    const ProjectReference = IDL.Record({
        'id' : IDL.Text,
        'name' : IDL.Text,
        'lastModified' : Timestamp,
        'visibility' : Visibility,
    });
    const AccountResources = IDL.Record({
        'deployments' : IDL.Vec(DeploymentReference__1),
        'templates' : IDL.Vec(TemplateReference),
        'projects' : IDL.Vec(ProjectReference),
    });
    const ActivityLog = IDL.Record({
        'activityType' : IDL.Text,
        'timestamp' : Timestamp,
        'details' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    });
    const AccountStats = IDL.Record({
        'storageUsed' : IDL.Nat64,
        'reputation' : IDL.Nat,
        'templatesPublished' : IDL.Nat,
        'projectsCreated' : IDL.Nat,
        'totalRevenue' : IDL.Nat64,
        'templatesSold' : IDL.Nat,
        'cyclesBalance' : IDL.Nat64,
        'lastActive' : Timestamp,
        'activity' : IDL.Vec(ActivityLog),
    });
    const NotificationSettings = IDL.Record({
        'enabled' : IDL.Bool,
        'muteTimeEnd' : IDL.Opt(IDL.Nat64),
        'eventTypes' : IDL.Vec(IDL.Text),
        'customSettings' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
        'frequency' : IDL.Opt(IDL.Text),
        'muteTimeStart' : IDL.Opt(IDL.Nat64),
    });
    const DiscordConfig = IDL.Record({
        'channelId' : IDL.Text,
        'notificationSettings' : NotificationSettings,
        'serverId' : IDL.Text,
        'webhookUrl' : IDL.Text,
    });
    const TelegramConfig = IDL.Record({
        'botEnabled' : IDL.Bool,
        'notificationSettings' : NotificationSettings,
        'chatId' : IDL.Text,
    });
    const WebhookConfig = IDL.Record({
        'id' : IDL.Text,
        'url' : IDL.Text,
        'active' : IDL.Bool,
        'secret' : IDL.Text,
        'events' : IDL.Vec(IDL.Text),
    });
    const GitHubConfig = IDL.Record({
        'webhookConfigs' : IDL.Vec(WebhookConfig),
        'tokenExpiry' : Timestamp,
        'accessToken' : IDL.Text,
        'connectedRepositories' : IDL.Vec(IDL.Text),
    });
    const ExternalServiceTokens = IDL.Record({
        'discord' : IDL.Opt(DiscordConfig),
        'telegram' : IDL.Opt(TelegramConfig),
        'github' : IDL.Opt(GitHubConfig),
    });
    const NotificationPreferences = IDL.Record({
        'channelPreferences' : IDL.Record({
            'email' : IDL.Bool,
            'discord' : IDL.Bool,
            'inApp' : IDL.Bool,
            'telegram' : IDL.Bool,
        }),
        'notificationTypes' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Bool))),
        'digestFrequency' : IDL.Opt(IDL.Text),
    });
    const DeploymentPreferences = IDL.Record({
        'cyclesRequirement' : IDL.Nat64,
        'network' : IDL.Text,
        'replica' : IDL.Text,
        'automaticDeployment' : IDL.Bool,
    });
    const ProjectFramework = IDL.Variant({
        'Vue' : IDL.Null,
        'Custom' : IDL.Text,
        'React' : IDL.Null,
        'Motoko' : IDL.Null,
    });
    const ProjectCategory = IDL.Variant({
        'Frontend' : IDL.Null,
        'FullStack' : IDL.Null,
        'Backend' : IDL.Null,
    });
    const ProjectType = IDL.Record({
        'framework' : ProjectFramework,
        'category' : ProjectCategory,
    });
    const AccessControlPreferences = IDL.Record({
        'allowedUsers' : IDL.Vec(IDL.Principal),
        'allowedRoles' : IDL.Vec(IDL.Text),
        'restrictedActions' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Text))),
        'visibility' : IDL.Text,
    });
    const BuildPreferences = IDL.Record({
        'artifacts' : IDL.Vec(IDL.Text),
        'variables' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
        'environment' : IDL.Text,
        'commands' : IDL.Vec(IDL.Text),
    });
    const VisibilityType = IDL.Variant({
        'Contacts' : IDL.Null,
        'Private' : IDL.Null,
        'Public' : IDL.Null,
    });
    const ProjectPreferences = IDL.Record({
        'deploymentPreferences' : IDL.Opt(DeploymentPreferences),
        'projectType' : ProjectType,
        'defaultPreferences' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
        'accessPreferences' : IDL.Opt(AccessControlPreferences),
        'buildPreferences' : IDL.Opt(BuildPreferences),
        'visibility' : VisibilityType,
    });
    const AccountPreferences = IDL.Record({
        'timezone' : IDL.Opt(IDL.Text),
        'notificationPreferences' : NotificationPreferences,
        'customPreferences' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
        'defaultProjectPreferences' : IDL.Opt(ProjectPreferences),
        'defaultVisibility' : Visibility,
        'sessionTimeout' : IDL.Opt(IDL.Nat64),
    });
    const AccountType = IDL.Variant({
        'Premium' : IDL.Null,
        'Enterprise' : IDL.Null,
        'Basic' : IDL.Null,
        'Custom' : IDL.Text,
    });
    const CanisterType = IDL.Variant({
        'Frontend' : IDL.Null,
        'Custom' : IDL.Text,
        'Asset' : IDL.Null,
        'Backend' : IDL.Null,
    });
    const CanisterSettings = IDL.Record({
        'duration' : IDL.Opt(IDL.Nat),
        'controllers' : IDL.Vec(IDL.Principal),
        'canisterType' : CanisterType,
        'freezingThreshold' : IDL.Nat,
        'name' : IDL.Text,
        'initialCycles' : IDL.Nat64,
        'memoryAllocation' : IDL.Nat,
        'computeAllocation' : IDL.Nat,
    });
    const AccountInfo = IDL.Record({
        'lastAccessed' : Timestamp,
        'createdAt' : Timestamp,
        'externalServices' : IDL.Opt(ExternalServiceTokens),
        'preferences' : IDL.Opt(AccountPreferences),
        'accountType' : AccountType,
        'canisterSettings' : IDL.Opt(CanisterSettings),
    });
    const CollaboratorStatus = IDL.Variant({
        'Invited' : IDL.Null,
        'Active' : IDL.Null,
        'Removed' : IDL.Null,
    });
    const Collaborator = IDL.Record({
        'status' : CollaboratorStatus,
        'permissions' : IDL.Vec(IDL.Text),
        'principal' : IDL.Principal,
        'expiresAt' : IDL.Opt(Timestamp),
        'role' : RoleType,
        'addedAt' : Timestamp,
    });
    const Account = IDL.Record({
        'id' : IDL.Principal,
        'created' : Timestamp,
        'owner' : IDL.Principal,
        'resources' : AccountResources,
        'stats' : AccountStats,
        'accountInfo' : AccountInfo,
        'collaborators' : IDL.Vec(Collaborator),
    });
    const Result_22 = IDL.Variant({ 'ok' : IDL.Principal, 'err' : IDL.Text });
    const Result_21 = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text });
    const Chunk = IDL.Record({
        'id' : ChunkId,
        'content' : IDL.Vec(IDL.Nat8),
        'size' : IDL.Nat,
    });
    const CourseProgress = IDL.Record({
        'completedAt' : IDL.Opt(IDL.Nat64),
        'startedAt' : IDL.Nat64,
        'completedVideos' : IDL.Vec(IDL.Text),
        'userId' : IDL.Principal,
        'lastWatchPosition' : IDL.Nat,
        'lastWatchedVideo' : IDL.Text,
        'courseId' : IDL.Text,
        'lastAccessedAt' : IDL.Nat64,
    });
    const LoggerConfig = IDL.Record({
        'retentionDays' : IDL.Nat,
        'maxSize' : IDL.Nat,
    });
    const TemplateMetadata = IDL.Record({
        'id' : IDL.Text,
        'created' : IDL.Nat64,
        'thumbnail' : IDL.Opt(IDL.Text),
        'publishingStatus' : IDL.Text,
        'name' : IDL.Text,
        'tags' : IDL.Vec(IDL.Text),
        'description' : IDL.Text,
        'author' : IDL.Principal,
        'pricing' : IDL.Opt(TemplatePricing),
        'version' : IDL.Text,
        'isFeatured' : IDL.Bool,
        'updated' : IDL.Nat64,
        'category' : IDL.Text,
        'downloads' : IDL.Nat,
    });
    const Result_20 = IDL.Variant({ 'ok' : Project, 'err' : IDL.Text });
    const Result_19 = IDL.Variant({
        'ok' : IDL.Vec(
            IDL.Record({
                'path' : IDL.Text,
                'mimeType' : IDL.Text,
                'fileName' : IDL.Text,
                'lastModified' : IDL.Nat,
                'language' : IDL.Text,
                'estimatedSize' : IDL.Nat,
            })
        ),
        'err' : IDL.Text,
    });
    FileTreeNode.fill(
        IDL.Record({
            'name' : IDL.Text,
            'path' : IDL.Text,
            'children' : IDL.Opt(IDL.Vec(FileTreeNode)),
            'isDirectory' : IDL.Bool,
        })
    );
    const Result_18 = IDL.Variant({ 'ok' : FileTreeNode, 'err' : IDL.Text });
    const Result_17 = IDL.Variant({
        'ok' : IDL.Record({
            'totalFiles' : IDL.Nat,
            'totalEstimatedSize' : IDL.Nat,
            'largeFiles' : IDL.Nat,
            'textFiles' : IDL.Nat,
            'averageFileSize' : IDL.Nat,
            'recommendedBatchSize' : IDL.Nat,
            'binaryFiles' : IDL.Nat,
        }),
        'err' : IDL.Text,
    });
    const Result_16 = IDL.Variant({
        'ok' : IDL.Vec(ProjectVersion),
        'err' : IDL.Text,
    });
    const Result_15 = IDL.Variant({ 'ok' : TemplateMetadata, 'err' : IDL.Text });
    const Result_13 = IDL.Variant({ 'ok' : ImageAsset, 'err' : IDL.Text });
    const VisibilityPreferences = IDL.Record({
        'projects' : Visibility,
        'stats' : Visibility,
        'activity' : Visibility,
        'profile' : Visibility,
    });
    const UserPreferences = IDL.Record({
        'theme' : IDL.Opt(IDL.Text),
        'notifications' : NotificationPreferences,
        'customPreferences' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
        'defaultProjectPreferences' : IDL.Opt(ProjectPreferences),
        'visibility' : VisibilityPreferences,
    });
    const UserSocials = IDL.Record({
        'twitter' : IDL.Opt(IDL.Text),
        'discord' : IDL.Opt(IDL.Text),
        'telegram' : IDL.Opt(IDL.Text),
        'openchat' : IDL.Opt(IDL.Text),
    });
    const UserProfile = IDL.Record({
        'bio' : IDL.Opt(IDL.Text),
        'coverPhotoAsset' : IDL.Opt(ImageAsset),
        'username' : IDL.Text,
        'displayName' : IDL.Opt(IDL.Text),
        'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
        'socials' : IDL.Opt(UserSocials),
        'avatarAsset' : IDL.Opt(ImageAsset),
        'email' : IDL.Opt(IDL.Text),
        'website' : IDL.Opt(IDL.Text),
        'coverPhoto' : IDL.Opt(IDL.Text),
        'github' : IDL.Opt(IDL.Text),
        'avatar' : IDL.Opt(IDL.Text),
    });
    const User = IDL.Record({
        'id' : IDL.Principal,
        'primaryAccountId' : IDL.Opt(IDL.Principal),
        'created' : IDL.Nat64,
        'preferences' : IDL.Opt(UserPreferences),
        'linkedAccounts' : IDL.Vec(IDL.Principal),
        'lastActive' : IDL.Nat64,
        'profile' : UserProfile,
    });
    const VideoProgress = IDL.Record({
        'timestamp' : IDL.Nat64,
        'watchDuration' : IDL.Nat,
        'courseId' : IDL.Text,
        'videoId' : IDL.Text,
    });
    const Certificate = IDL.Record({
        'earnedAt' : IDL.Nat64,
        'certificateId' : IDL.Text,
        'courseId' : IDL.Text,
    });
    const UserCourseData = IDL.Record({
        'completedCourses' : IDL.Vec(IDL.Text),
        'favoriteSubjects' : IDL.Vec(IDL.Text),
        'progress' : IDL.Vec(CourseProgress),
        'watchHistory' : IDL.Vec(VideoProgress),
        'certificatesEarned' : IDL.Vec(Certificate),
        'enrolledCourses' : IDL.Vec(IDL.Text),
    });
    const Metadata = IDL.Record({
        'balance' : IDL.Nat,
        'cycleBalance' : IDL.Nat64,
        'moduleHash' : IDL.Opt(IDL.Vec(IDL.Nat8)),
        'lastUpdated' : IDL.Nat64,
        'totalKeys' : IDL.Nat,
        'memoryUsage' : IDL.Nat64,
        'version' : IDL.Text,
        'uptime' : IDL.Nat64,
        'totalUsers' : IDL.Nat,
        'idleCyclesBurnedPerDay' : IDL.Nat,
        'stableStateSize' : IDL.Nat,
        'stableMemoryUsage' : IDL.Nat,
        'heapMemoryUsage' : IDL.Nat64,
        'memorySize' : IDL.Nat,
    });
    const TransactionType = IDL.Variant({
        'sent' : IDL.Null,
        'canister' : IDL.Null,
        'received' : IDL.Null,
    });
    const Transaction = IDL.Record({
        'transactionType' : TransactionType,
        'isPositive' : IDL.Bool,
        'memo' : IDL.Opt(IDL.Text),
        'counterparty' : IDL.Text,
        'timestamp' : IDL.Int,
        'amount' : IDL.Nat,
    });
    const Result_4 = IDL.Variant({ 'ok' : User, 'err' : IDL.Text });
    const Result_10 = IDL.Variant({
        'ok' : IDL.Record({
            'totalFiles' : IDL.Nat,
            'totalBatches' : IDL.Nat,
            'sessionId' : IDL.Text,
            'batchSize' : IDL.Nat,
        }),
        'err' : IDL.Text,
    });
    const Result_9 = IDL.Variant({
        'ok' : IDL.Record({
            'totalSize' : IDL.Nat,
            'totalChunks' : IDL.Nat,
            'chunkSize' : IDL.Nat,
            'sessionId' : IDL.Text,
        }),
        'err' : IDL.Text,
    });
    const Result_8 = IDL.Variant({ 'ok' : Account, 'err' : IDL.Text });
    const Result = IDL.Variant({
        'ok' : IDL.Record({ 'receivedChunks' : IDL.Nat, 'totalChunks' : IDL.Nat }),
        'err' : IDL.Text,
    });
    return IDL.Service({
        'addCanisterMetadata' : IDL.Func([IDL.Principal, CanisterMetadata], [], []),
        'addCanisterToProject' : IDL.Func(
            [IDL.Text, IDL.Principal, IDL.Opt(IDL.Text)],
            [Result_6],
            [],
        ),
        'addCollaborator' : IDL.Func(
            [IDL.Principal, RoleType, IDL.Vec(IDL.Text), IDL.Opt(Timestamp)],
            [Result_3],
            [],
        ),
        'addDeploymentToAccount' : IDL.Func(
            [
                IDL.Text,
                IDL.Text,
                IDL.Text,
                IDL.Opt(IDL.Principal),
                IDL.Text,
                IDL.Text,
            ],
            [Result_3],
            [],
        ),
        'addDeploymentToVersion' : IDL.Func(
            [IDL.Text, DeploymentReference],
            [Result_2],
            [],
        ),
        'addExternalService' : IDL.Func(
            [IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
            [Result_3],
            [],
        ),
        'addGitHubWebhook' : IDL.Func(
            [IDL.Text, IDL.Text, IDL.Vec(IDL.Text)],
            [Result_6],
            [],
        ),
        'addNpmPackageToProject' : IDL.Func(
            [IDL.Text, NPMPackageInfo],
            [Result_6],
            [],
        ),
        'addPackageToProject' : IDL.Func(
            [IDL.Text, PackageInfo, IDL.Opt(IDL.Text)],
            [Result_6],
            [],
        ),
        'addProjectToAccount' : IDL.Func(
            [IDL.Text, IDL.Text, Visibility],
            [Result_3],
            [],
        ),
        'addTemplatePreviewImage' : IDL.Func(
            [IDL.Text, ImageAsset],
            [Result_5],
            [],
        ),
        'addTemplateToAccount' : IDL.Func(
            [IDL.Text, IDL.Text, Visibility, IDL.Opt(IDL.Nat64)],
            [Result_3],
            [],
        ),
        'addTemplateVersion' : IDL.Func(
            [IDL.Text, TemplateVersion],
            [Result_5],
            [],
        ),
        'cleanOldLogs' : IDL.Func([], [], []),
        'cleanupExpiredSessions' : IDL.Func([], [], ['oneway']),
        'cleanupProjectFilesDownloadSession' : IDL.Func([IDL.Text], [Result_6], []),
        'cleanupWasmDownloadSession' : IDL.Func([IDL.Text], [Result_6], []),
        'clearAllLogs' : IDL.Func([], [IDL.Nat], []),
        'copyVersionArtifacts' : IDL.Func([IDL.Text, IDL.Text], [Result_2], []),
        'createCanisterWithSettings' : IDL.Func(
            [
                IDL.Principal,
                IDL.Nat,
                IDL.Nat,
                IDL.Opt(IDL.Nat),
                IDL.Nat,
                IDL.Nat,
                IDL.Text,
                IDL.Text,
            ],
            [Result_6],
            [],
        ),
        'createCodeArtifact' : IDL.Func(
            [
                IDL.Principal,
                IDL.Text,
                IDL.Text,
                FileContent,
                IDL.Text,
                IDL.Text,
                IDL.Text,
                IDL.Opt(IDL.Text),
            ],
            [Result_7],
            [],
        ),
        'createCodeArtifactForVersion' : IDL.Func(
            [
                IDL.Principal,
                IDL.Text,
                IDL.Text,
                FileContent,
                IDL.Text,
                IDL.Text,
                IDL.Text,
            ],
            [Result_12],
            [],
        ),
        'createMultipleCodeArtifacts' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Vec(FileData), IDL.Opt(IDL.Text)],
            [Result_14],
            [],
        ),
        'createProject' : IDL.Func([Project, IDL.Opt(IDL.Bool)], [Result_6], []),
        'createProjectVersion' : IDL.Func(
            [
                IDL.Text,
                IDL.Nat,
                IDL.Nat,
                IDL.Nat,
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
            ],
            [Result_2],
            [],
        ),
        'createTemplate' : IDL.Func([Template], [Result_5], []),
        'createUserWallet' : IDL.Func([], [IDL.Text], []),
        'createVersionArtifacts' : IDL.Func(
            [IDL.Text, IDL.Vec(ArtifactFile)],
            [Result_11],
            [],
        ),
        'deleteCanister' : IDL.Func([IDL.Principal], [Result_6], []),
        'deleteCodeArtifact' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Text, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_6],
            [],
        ),
        'deleteDeployment' : IDL.Func(
            [IDL.Text, IDL.Opt(IDL.Text)],
            [Result_6],
            [],
        ),
        'deleteImportedTemplate' : IDL.Func([IDL.Text], [Result_6], []),
        'deleteProject' : IDL.Func([IDL.Text], [Result_6], []),
        'deleteProjectFromAccount' : IDL.Func([IDL.Text], [Result_3], []),
        'deleteProjectVersion' : IDL.Func([IDL.Text], [Result_3], []),
        'deleteTemplate' : IDL.Func([IDL.Text], [Result_6], []),
        'deployBackendWithCustomInit' : IDL.Func(
            [
                IDL.Principal,
                IDL.Vec(IDL.Nat8),
                IDL.Vec(IDL.Nat8),
                IDL.Opt(CanisterMetadata),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
            ],
            [Result_6],
            [],
        ),
        'deployStoredWasm' : IDL.Func(
            [
                IDL.Text,
                IDL.Text,
                IDL.Principal,
                IDL.Text,
                IDL.Text,
                IDL.Principal,
                IDL.Opt(CanisterMetadata),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
            ],
            [Result_6],
            [],
        ),
        'deployToExistingCanister' : IDL.Func(
            [
                IDL.Principal,
                IDL.Vec(IDL.Nat8),
                IDL.Text,
                IDL.Text,
                IDL.Principal,
                IDL.Opt(CanisterMetadata),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
            ],
            [Result_6],
            [],
        ),
        'downloadLargeFileIndividually' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Text, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_25],
            [],
        ),
        'downloadProjectFilesBatch' : IDL.Func(
            [IDL.Text, IDL.Nat],
            [Result_24],
            [],
        ),
        'downloadWasmChunk' : IDL.Func([IDL.Text, IDL.Nat], [Result_23], []),
        'enrollInCourse' : IDL.Func([IDL.Text], [Result_1], []),
        'exportTemplateForCreator' : IDL.Func([IDL.Text], [Result_6], []),
        'finalizeWasmUpload' : IDL.Func([IDL.Text], [Result_6], []),
        'getAccountDetails' : IDL.Func([], [IDL.Opt(Account)], ['query']),
        'getAccountIdByUsername' : IDL.Func([IDL.Text], [Result_22], []),
        'getAllTemplates' : IDL.Func([], [IDL.Vec(Template)], []),
        'getCanisterBalance' : IDL.Func([IDL.Principal], [Result_21], []),
        'getCanisterMetadata' : IDL.Func(
            [IDL.Principal],
            [IDL.Opt(CanisterMetadata)],
            [],
        ),
        'getCanisterStatus' : IDL.Func([IDL.Principal], [Result_6], []),
        'getChunk' : IDL.Func([ChunkId], [IDL.Opt(Chunk)], []),
        'getCourseProgress' : IDL.Func(
            [IDL.Text],
            [IDL.Opt(CourseProgress)],
            ['query'],
        ),
        'getCycleBalance' : IDL.Func([], [IDL.Nat], []),
        'getExternalServices' : IDL.Func(
            [],
            [IDL.Opt(ExternalServiceTokens)],
            ['query'],
        ),
        'getFileDownloadSystemHealth' : IDL.Func(
            [],
            [
                IDL.Record({
                    'recommendedAction' : IDL.Text,
                    'activeSessions' : IDL.Nat,
                    'systemStatus' : IDL.Text,
                }),
            ],
            ['query'],
        ),
        'getLatestProjectVersion' : IDL.Func([IDL.Text], [Result_2], []),
        'getLinkedAccounts' : IDL.Func([], [IDL.Vec(IDL.Principal)], ['query']),
        'getLoggerConfig' : IDL.Func([], [LoggerConfig], ['query']),
        'getLogs' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
        'getLogsByLevel' : IDL.Func([IDL.Text], [IDL.Vec(IDL.Text)], ['query']),
        'getMyTemplates' : IDL.Func([], [IDL.Vec(Template)], ['query']),
        'getMyTemplatesMetadata' : IDL.Func(
            [],
            [IDL.Vec(TemplateMetadata)],
            ['query'],
        ),
        'getNewLogsSince' : IDL.Func(
            [IDL.Nat, IDL.Opt(IDL.Nat)],
            [IDL.Record({ 'logs' : IDL.Vec(IDL.Text), 'nextMarker' : IDL.Nat })],
            ['query'],
        ),
        'getProject' : IDL.Func([IDL.Text], [Result_20], []),
        'getProjectFileMetadata' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_19],
            [],
        ),
        'getProjectFileTree' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_18],
            [],
        ),
        'getProjectFiles' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_14],
            [],
        ),
        'getProjectStatistics' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_17],
            [],
        ),
        'getProjectVersion' : IDL.Func([IDL.Text], [Result_2], []),
        'getProjectVersions' : IDL.Func([IDL.Text], [Result_16], []),
        'getTemplate' : IDL.Func([IDL.Text], [Result_5], ['query']),
        'getTemplateForBuyer' : IDL.Func([IDL.Text], [Result_5], ['query']),
        'getTemplateMetadata' : IDL.Func([IDL.Text], [Result_15], ['query']),
        'getTemplatePreviewImage' : IDL.Func(
            [IDL.Text, IDL.Nat],
            [Result_13],
            ['query'],
        ),
        'getTemplateProjectFiles' : IDL.Func(
            [IDL.Text, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_14],
            [],
        ),
        'getTemplateThumbnailImage' : IDL.Func([IDL.Text], [Result_13], ['query']),
        'getTemplatesByOwner' : IDL.Func(
            [IDL.Principal],
            [IDL.Vec(Template)],
            ['query'],
        ),
        'getTotalTemplatesCount' : IDL.Func([], [IDL.Nat], ['query']),
        'getUserAccountInfo' : IDL.Func([], [IDL.Opt(User)], ['query']),
        'getUserBalance' : IDL.Func([], [IDL.Nat], []),
        'getUserCanisters' : IDL.Func(
            [],
            [
                IDL.Vec(
                    IDL.Record({
                        'principal' : IDL.Principal,
                        'canisterType' : IDL.Text,
                        'name' : IDL.Text,
                    })
                ),
            ],
            [],
        ),
        'getUserCourseData' : IDL.Func([], [IDL.Opt(UserCourseData)], ['query']),
        'getUserProjects' : IDL.Func([], [IDL.Vec(Project)], ['query']),
        'getUserStateMetadata' : IDL.Func([], [Metadata], []),
        'getUserWalletId' : IDL.Func(
            [],
            [
                IDL.Opt(
                    IDL.Record({
                        'principal' : IDL.Text,
                        'subaccount' : IDL.Text,
                        'accountIdentifier' : IDL.Text,
                    })
                ),
            ],
            ['query'],
        ),
        'getVersionArtifactFile' : IDL.Func(
            [IDL.Text, IDL.Text, IDL.Text],
            [Result_12],
            [],
        ),
        'getVersionArtifacts' : IDL.Func([IDL.Text], [Result_11], []),
        'getVersionByString' : IDL.Func([IDL.Text, IDL.Text], [Result_2], []),
        'getWalletTransactions' : IDL.Func(
            [IDL.Opt(IDL.Nat)],
            [IDL.Vec(Transaction)],
            ['query'],
        ),
        'importTemplate' : IDL.Func([Template], [Result_5], []),
        'initializeProjectVersion' : IDL.Func([IDL.Text], [Result_2], []),
        'initializeUserAccount' : IDL.Func([UserProfile], [Result_4], []),
        'isCanisterController' : IDL.Func([IDL.Principal], [IDL.Bool], []),
        'isModuleInstalled' : IDL.Func([IDL.Principal], [Result_1], []),
        'linkAccount' : IDL.Func([IDL.Principal], [Result_3], []),
        'logDebug' : IDL.Func([IDL.Text], [], []),
        'logError' : IDL.Func([IDL.Text], [], []),
        'logInfo' : IDL.Func([IDL.Text], [], []),
        'logWarn' : IDL.Func([IDL.Text], [], []),
        'migratePathsToStandard' : IDL.Func([], [], []),
        'promoteVersionToWorkingCopy' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Text, IDL.Bool],
            [Result_6],
            [],
        ),
        'readCodeArtifact' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Text, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_7],
            [],
        ),
        'recordTemplateSale' : IDL.Func([IDL.Text, IDL.Nat64], [Result_3], []),
        'removeCanisterFromProject' : IDL.Func(
            [IDL.Text, IDL.Principal, IDL.Opt(IDL.Text)],
            [Result_6],
            [],
        ),
        'removeCanisterMetadata' : IDL.Func([IDL.Principal], [], []),
        'removeExternalService' : IDL.Func([IDL.Text], [Result_3], []),
        'removeNpmPackageFromProject' : IDL.Func(
            [IDL.Text, IDL.Text],
            [Result_6],
            [],
        ),
        'removePackageFromProject' : IDL.Func([IDL.Text, IDL.Text], [Result_6], []),
        'removeTemplatePreviewImage' : IDL.Func(
            [IDL.Text, IDL.Nat],
            [Result_5],
            [],
        ),
        'sendICP' : IDL.Func(
            [IDL.Principal, IDL.Principal, IDL.Nat],
            [Result_6],
            [],
        ),
        'sendICPToAccountId' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Nat],
            [Result_6],
            [],
        ),
        'setLocalMode' : IDL.Func([IDL.Bool], [], []),
        'setPrimaryAccount' : IDL.Func([IDL.Principal], [Result_3], []),
        'startCanister' : IDL.Func([IDL.Principal], [Result_6], []),
        'startProjectFilesDownloadSession' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_10],
            [],
        ),
        'startWasmDownloadSession' : IDL.Func(
            [IDL.Text, IDL.Text, IDL.Text],
            [Result_9],
            [],
        ),
        'startWasmUploadSession' : IDL.Func(
            [
                IDL.Text,
                IDL.Text,
                IDL.Nat,
                IDL.Nat,
                IDL.Opt(IDL.Principal),
                IDL.Opt(IDL.Text),
                IDL.Opt(IDL.Text),
            ],
            [Result_6],
            [],
        ),
        'stopCanister' : IDL.Func([IDL.Principal], [Result_6], []),
        'testLogSequence' : IDL.Func(
            [],
            [
                IDL.Record({
                    'afterLog' : IDL.Nat,
                    'before' : IDL.Nat,
                    'afterIncrement' : IDL.Nat,
                }),
            ],
            [],
        ),
        'testWalletFunctionality' : IDL.Func([], [IDL.Text], []),
        'topUpCanister' : IDL.Func([IDL.Principal, IDL.Float64], [Result_6], []),
        'topUpCanisterCMC' : IDL.Func(
            [IDL.Principal, IDL.Principal, IDL.Nat],
            [Result_6],
            [],
        ),
        'topUpExternalCanister' : IDL.Func([IDL.Text, IDL.Float64], [Result_6], []),
        'topUpSelf' : IDL.Func([IDL.Float64], [Result_6], []),
        'unlinkAccount' : IDL.Func([IDL.Principal], [Result_3], []),
        'updateAccountCanisterSettings' : IDL.Func(
            [CanisterSettings],
            [Result_3],
            [],
        ),
        'updateAccountCyclesBalance' : IDL.Func([IDL.Nat64], [Result_3], []),
        'updateAccountPreferences' : IDL.Func([AccountPreferences], [Result_8], []),
        'updateAccountProject' : IDL.Func(
            [IDL.Text, IDL.Text, Visibility],
            [Result_3],
            [],
        ),
        'updateAccountStorageUsed' : IDL.Func([IDL.Nat64], [Result_3], []),
        'updateAccountType' : IDL.Func([AccountType], [Result_3], []),
        'updateCanisterMetadata' : IDL.Func(
            [IDL.Principal, CanisterMetadata],
            [],
            [],
        ),
        'updateCanisterMetadataBC' : IDL.Func(
            [IDL.Principal, IDL.Text, IDL.Text],
            [Result_6],
            [],
        ),
        'updateCodeArtifact' : IDL.Func(
            [
                IDL.Principal,
                IDL.Text,
                IDL.Text,
                FileContent,
                IDL.Text,
                IDL.Opt(IDL.Text),
            ],
            [Result_7],
            [],
        ),
        'updateCollaboratorStatus' : IDL.Func(
            [IDL.Principal, CollaboratorStatus],
            [Result_3],
            [],
        ),
        'updateDeploymentStatus' : IDL.Func([IDL.Text, IDL.Text], [Result_3], []),
        'updateDeploymentStatusWithVersion' : IDL.Func(
            [IDL.Text, IDL.Text, IDL.Opt(IDL.Text)],
            [Result_3],
            [],
        ),
        'updateGitHubRepositories' : IDL.Func([IDL.Vec(IDL.Text)], [Result_3], []),
        'updateImportedTemplate' : IDL.Func([Template], [Result_5], []),
        'updateLoggerConfig' : IDL.Func([IDL.Nat, IDL.Nat], [], []),
        'updateNotificationPreferences' : IDL.Func(
            [NotificationPreferences],
            [Result_3],
            [],
        ),
        'updateProject' : IDL.Func(
            [Project, IDL.Bool, IDL.Opt(IDL.Text)],
            [Result_6],
            [],
        ),
        'updateTemplate' : IDL.Func([Template], [Result_5], []),
        'updateTemplateThumbnailImage' : IDL.Func(
            [IDL.Text, ImageAsset],
            [Result_5],
            [],
        ),
        'updateUserPreferences' : IDL.Func([UserPreferences], [Result_4], []),
        'updateUserProfile' : IDL.Func([UserProfile], [Result_4], []),
        'updateUserReputation' : IDL.Func([IDL.Nat], [Result_3], []),
        'updateVersionCanisters' : IDL.Func(
            [IDL.Text, IDL.Opt(IDL.Vec(IDL.Principal))],
            [Result_2],
            [],
        ),
        'updateVersionPackages' : IDL.Func(
            [
                IDL.Text,
                IDL.Opt(IDL.Vec(PackageInfo)),
                IDL.Opt(IDL.Vec(NPMPackageInfo)),
            ],
            [Result_2],
            [],
        ),
        'updateVersionStatus' : IDL.Func([IDL.Text, IDL.Text], [Result_2], []),
        'updateVideoProgress' : IDL.Func(
            [IDL.Text, IDL.Text, IDL.Nat, IDL.Bool],
            [Result_1],
            [],
        ),
        'uploadWasmChunk' : IDL.Func(
            [IDL.Text, IDL.Nat, IDL.Vec(IDL.Nat8)],
            [Result],
            [],
        ),
        'wallet_receive' : IDL.Func(
            [],
            [IDL.Record({ 'accepted' : IDL.Nat64 })],
            [],
        ),
    });
};
export const init = ({ IDL }) => { return []; };
